import { render, staticRenderFns } from "./QMarketingSubmenu.vue?vue&type=template&id=03846ceb&"
import script from "./QMarketingSubmenu.vue?vue&type=script&lang=js&"
export * from "./QMarketingSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports